(function (w, $) {
    const assetId = '~/Controls/MsForm/Feedback_fileupload.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    w.require(['plupload'], function (plupload) {
        for (let ctx of w.umwAssets[assetId]) {
            $(function() {
                const fileList = $('#' + ctx.fileListId);
                const selectFiles = $('#' + ctx.selectFilesId);
                const currentFileCount = $('#' + ctx.currentFileCountId);
                const fileListBody = $('#' + ctx.fileListBodyId);
                const fileListContainer = $('#' + ctx.fileListContainerId);
                const fileListFooter = $('#' + ctx.fileListFooterId);
                const btnSend = $('#' + ctx.btnSendId);

                //Plupload
                var uploadedFiles = [];
                var uploader = new plupload.Uploader({
                    browse_button: ctx.selectFilesId,
                    drop_element: ctx.fileListId,
                    container: ctx.fileListContainerId,
                    url: w.R +
                        'Startup/Archive/Plupload.ashx?action=feedback&FolderID=' +
                        ctx.fileUploadFolderId +
                        '&Publish=true',
                    max_file_size: '10mb',
                    chunk_size: '1mb',
                    multipart: false,
                    multi_selection: false,
                    maxFileCount: ctx.fileUploadCount,
                    flash_swf_url: w.R + 'js/plupload-2.3.6/Moxie.swf',
                    silverlight_xap_url: w.R + 'js/plupload-2.3.6/Moxie.xap'
                });

                uploader.bind('Init',
                    function(up, params) {
                        fileList.html("<li style='display: none;'>Current runtime: " + params.runtime + "</li>");
                        if (params.runtime == 'html5') {
                            fileList.append('<li class="DragHereMessage"><div>Drag files here</div></li>');
                        } else {
                            fileList.css('display', 'none');
                        }
                    });

                uploader.bind('QueueChanged',
                    function(up) {
                        // Called when files are added to queue
                        const isLimitReached = up.files.length < up.settings.maxFileCount;
                        up.disableBrowse(!isLimitReached);
                        selectFiles.toggle(isLimitReached);

                        currentFileCount.text(up.files.length);
                        fileList.toggle(!(up.runtime !== 'html5' && up.files.length === 0));
                        fileList.find(' .DragHereMessage').toggle(up.runtime === 'html5' && up.files.length === 0);
                    });

                uploader.init();

                uploader.bind('FilesAdded',
                    function(up, files) {
                        $.each(files,
                            function(i, file) {
                                const listIemElem = $('<li/>',
                                    {
                                        'class': up.files.length === 1 ? 'FileItem first' : 'FileItem',
                                        id: file.id
                                    });

                                const removeLinkElem = $('<a/>',
                                    {
                                        'class': 'RemoveFileLink',
                                        href: '#',
                                        title: 'Remove file',
                                        click: function(e) {
                                            $('#' + file.id).remove();
                                            up.removeFile(file);
                                            e.preventDefault();
                                        }
                                    });
                                fileList.append(listIemElem.append(removeLinkElem,
                                    file.name +
                                    ' (' +
                                    plupload.formatSize(file.size) +
                                    ') <span class="UploadPercentage"></span>'));
                            });

                        up.refresh(); // Reposition Flash/Silverlight
                    });

                uploader.bind('UploadProgress',
                    function(up, file) {
                        $('#' + file.id + " .UploadPercentage").html(file.percent + "%");
                    });

                uploader.bind('Error',
                    function(up, err) {
                        const simpleErrorMessage = err.file
                            ? 'Failed to upload the file: ' + err.file.name
                            : 'An error has occured while uploading the file';

                        fileListBody.html('<div class="ErrorStatus">' +
                            simpleErrorMessage +
                            '</div><a href="#" onclick="jQuery(this).next().toggle(); return false;">More info</a><div class="DetailedErrorInfo" style="display:none;">Error: ' +
                            err.code +
                            ', Message: ' +
                            err.message +
                            '</div>');
                        fileListContainer.addClass('ErrorStatus');
                        fileListFooter.hide();
                        uploader.stop();
                        up.refresh(); // Reposition Flash/Silverlight
                    });

                uploader.bind('FileUploaded',
                    function(up, file, resp) {
                        if (file.status === plupload.DONE) {
                            const response = $.parseJSON(resp.response.replace(/\\/g, "\\\\"));
                            if (response && response.error) {
                                const ex = response.error;
                                ex.file = file;
                                up.trigger("Error", ex);
                            } else {
                                uploadedFiles.push('"' + response + '":"' + file.name + '"');
                            }
                        }
                    });

                // Upload files before Sending feedback
                btnSend.click(function(e) {
                    if (uploader.total.queued == 0) return true;
                    // Validate page first
                    var validationResult = true;
                    if (typeof (w.Page_ClientValidate) == 'function') {
                        validationResult = w.Page_ClientValidate(ctx.validationGroup);
                    }
                    if (validationResult) {
                        // Disable Send button to prevent accidental multiple click whil uploading the files
                        $(this).addClass('disabled').attr('disabled', 'disabled');
                        uploader.start();
                        e.preventDefault();
                    }
                });

                uploader.bind('UploadComplete',
                    function(up) {
                        // Perform simple serialization to JSON
                        if (up.total.failed > 0) return;
                        const json = '{' + uploadedFiles.join(',') + '}';
                        $('#' + ctx.uploadedFilesId).val(json);
                        w.__doPostBack(ctx.btnSendUid, '');
                    });

                // Cancel uploading if user navigates away from the page
                $(w).unload(function() {
                    uploader.stop();
                });
            });
        }
    });
})(window, jQuery);